/**
 * City of Reedley Header Component
 * Persistent header for landing page and app shell
 */

export function CityHeader() {
  return (
    <div className="bg-card border-b border-border">
      <div className="container py-4">
        <div className="flex flex-col gap-1">
          <h1 className="text-[20px] font-bold text-foreground">
            City of Reedley
          </h1>
          <p className="text-[13px] text-secondary-foreground">
            Water & Wastewater Operations Portal
          </p>
        </div>
      </div>
    </div>
  );
}
